<template>
  <v-container>
    <v-row justify="center">
      <p class="logo">まいにちエコチェッカー</p>
    </v-row>
    <v-row justify="center" class="sub-title">Produced by Innoqua</v-row>
  </v-container>
</template>

<script>
export default {
  name: "TitleLogo",
  data: () => ({}),
  methods: {}
};
</script>

<style scoped>
.logo {
  font-family: "Hiragino Maru Gothic ProN";
  color: #ffffff;
  font-size: 2.5em;
  margin-bottom: 0;
}
.sub-title {
  color: #ffffff;
}
@media screen and (max-width: 350px) {
  .logo {
    font-size: 1.5em;
  }
}
@media screen and (min-width: 351px) and (max-width: 768px) {
  .logo {
    font-size: 2em;
  }
}
@media screen and (min-width: 768px) and (max-width: 1024px) {
  .logo {
    font-size: 3em;
  }
}
</style>
